import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { areFilterableListItemsEqual, isFilterableListItemEmpty, filterFilterableList, getFilterableListItemLabel, isFilterableListItemDisabled, renderFilterableListItem, } from '../FilterableList';
import { SelectBase } from '../SelectBase';
import { ListItem } from '../ListItem';
import { useSelect } from './useSelect';
export const Select = forwardRef(function Select(props, fowardedRef) {
    const { getValueFieldProps, value, defaultValue, onChange, noResultsLabel, ...other } = props;
    const { defaultItem, selectedItem } = useSelect({
        items: other.items,
        itemEmpty: isFilterableListItemEmpty,
        defaultValue,
        value,
    });
    return (_jsx(SelectBase, { itemsEqual: areFilterableListItemsEqual, itemEmpty: isFilterableListItemEmpty, listPredicate: filterFilterableList, itemDisabled: isFilterableListItemDisabled, noResults: noResultsLabel ? (_jsx(ListItem, { disabled: true, children: noResultsLabel })) : undefined, ...other, itemRenderer: renderFilterableListItem, itemLabel: getFilterableListItemLabel, getValueFieldProps: (renderProps, selectedItem) => ({
            leadingIcon: selectedItem?.icon,
            ...getValueFieldProps?.(renderProps, selectedItem),
        }), defaultItem: defaultItem, selectedItem: selectedItem, onItemChange: (item) => onChange?.(item?.value), leadingIcon: selectedItem?.icon, ref: fowardedRef }));
});
